import React from 'react';

export default function Wifi() {
  return (
    <svg width="44" height="38" viewBox="0 0 44 38">
      <path d="M9.25,32.15a2.92,2.92,0,0,0,0-3.88A17.43,17.43,0,0,1,4.93,16.5,17.43,17.43,0,0,1,9.25,4.72a3,3,0,0,0,0-3.9A2.19,2.19,0,0,0,5.8.85,23.35,23.35,0,0,0,0,16.5,23.35,23.35,0,0,0,5.8,32.15,2.18,2.18,0,0,0,9.25,32.15Zm7-6.13a2.8,2.8,0,0,0,0-3.82A9.1,9.1,0,0,1,14,16.34a8.63,8.63,0,0,1,2.25-5.72,2.8,2.8,0,0,0,0-3.82,2.3,2.3,0,0,0-3.53,0,14.46,14.46,0,0,0,0,19.33,2.35,2.35,0,0,0,1.75.83A1.86,1.86,0,0,0,16.24,26Zm2.91-11.88a4,4,0,1,0,5.7,0A4.11,4.11,0,0,0,19.15,14.15Zm6.59,13a3.77,3.77,0,1,0-7.5,0L17,38H27Z" />
      <path d="M34.75,32.15a2.92,2.92,0,0,1,0-3.88A17.43,17.43,0,0,0,39.07,16.5,17.43,17.43,0,0,0,34.75,4.72a3,3,0,0,1,0-3.9,2.19,2.19,0,0,1,3.45,0A23.35,23.35,0,0,1,44,16.5a23.35,23.35,0,0,1-5.8,15.65A2.18,2.18,0,0,1,34.75,32.15Zm-7-6.13a2.8,2.8,0,0,1,0-3.82A9.1,9.1,0,0,0,30,16.34a8.63,8.63,0,0,0-2.25-5.72,2.8,2.8,0,0,1,0-3.82,2.3,2.3,0,0,1,3.53,0,14.46,14.46,0,0,1,0,19.33,2.35,2.35,0,0,1-1.75.83A1.86,1.86,0,0,1,27.76,26Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Wifi/index.js